import { observer } from 'mobx-react';
import { DefaultButton, IButtonStyles } from 'office-ui-fabric-react/lib/Button';
import { IContextualMenuProps } from 'office-ui-fabric-react/lib/components/ContextualMenu';
import { IIconProps } from 'office-ui-fabric-react/lib/Icon';
import * as React from 'react';
import { getPalette } from 'owa-theme';

const styles = require('./MeetingActionButton.scss');

export interface MeetingActionButtonProperties {
    text: string;
    iconProps: IIconProps;
    secondary?: boolean;
    onClick?: () => void;
    disabled?: boolean;
    menuProps?: IContextualMenuProps;
}

@observer
export default class MeetingActionButton extends React.Component<
    MeetingActionButtonProperties,
    null
> {
    render() {
        return (
            <DefaultButton
                className={styles.actionButton}
                text={this.props.text}
                styles={this.calculateCommandButtonCustomStyle(this.props.secondary)}
                onClick={this.props.onClick}
                iconProps={this.props.iconProps}
                disabled={this.props.disabled}
                menuProps={this.props.menuProps}
            />
        );
    }

    calculateCommandButtonCustomStyle(isSecondary: boolean): IButtonStyles {
        const themeSymbols = getPalette();
        const customStyle: IButtonStyles = {
            root: isSecondary
                ? {
                      color: themeSymbols.themePrimary,
                      backgroundColor: themeSymbols.neutralLighterAlt,
                      borderColor: themeSymbols.neutralLighterAlt,
                      padding: '0 3px',
                  }
                : {
                      color: themeSymbols.themePrimary,
                      backgroundColor: themeSymbols.white,
                      borderColor: themeSymbols.neutralLight,
                  },
            label: isSecondary
                ? {
                      fontWeight: 'normal',
                  }
                : {},
            rootHovered: {
                color: themeSymbols.neutralPrimary,
                backgroundColor: themeSymbols.neutralLight,
            },

            rootPressed: {
                color: themeSymbols.neutralPrimary,
                backgroundColor: themeSymbols.neutralTertiaryAlt,
            },

            rootExpanded: {
                color: themeSymbols.neutralPrimary,
                backgroundColor: themeSymbols.neutralLight,
            },

            rootExpandedHovered: {
                color: themeSymbols.neutralPrimary,
                backgroundColor: themeSymbols.neutralTertiary,
            },
        };

        return customStyle;
    }
}
